export interface StartingDataRow {
  material: string
  insert: string
  speed: string
  doc: string
  feed: string
  source: string
}

export const startingDataColumns = [
  'Material / application',
  'Insert style',
  'Speed',
  'DOC per side',
  'Feed',
  'Original source condition',
]

export const startingDataRows: StartingDataRow[] = [
  {
    material: '6061-T6 roughing',
    insert: 'APGX 331R or 332R MG12',
    speed: 'No numeric SFM published',
    doc: '.050–.300 in',
    feed: '.025–.050 IPR',
    source: 'Legacy data states a 20 hp CNC lathe',
  },
  {
    material: '6061-T6 chip control',
    insert: 'MG12 -30R chipbreaker',
    speed: 'No numeric SFM published',
    doc: '.015–.300 in',
    feed: '.010–.020 IPR',
    source:
      'No separate machine condition stated beyond the surrounding 6061-T6 guidance',
  },
  {
    material: 'Oxygen-free copper starting point',
    insert: 'Insert SKU not stated',
    speed: '1,000 SFM for copper',
    doc: 'Start at .050 in',
    feed: 'Start at .025 IPR',
    source: 'Peck .015 in feed / .010 in retract',
  },
  {
    material: 'Titanium starting range',
    insert: 'APGX 331R/332R DR80 honed/MAX coated',
    speed: '100–200 SFM',
    doc: 'Up to .400 in',
    feed: '.003–.007 IPR',
    source: 'Legacy suggested data; test conditions not supplied',
  },
]

export const startingDataNote =
  'The peck values above apply specifically to oxygen-free copper in the source text. The legacy page also advises a peck cycle for copper and soft aluminum alloys but does not provide complete test conditions. Obtain Robertson Precision’s current technical approval and validate every value against the machine, workholding, part and shop safety requirements before use.'
